import { render, staticRenderFns } from "./table-show-range-body.vue?vue&type=template&id=1fb966c8"
import script from "./table-show-range-body.vue?vue&type=script&lang=ts"
export * from "./table-show-range-body.vue?vue&type=script&lang=ts"
import style0 from "./table-show-range-body.vue?vue&type=style&index=0&id=1fb966c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports